// Generated by CoffeeScript 1.12.7
(function() {
  var key, ref, val;

  ref = require('./coffee-script');
  for (key in ref) {
    val = ref[key];
    exports[key] = val;
  }

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/coffee-script/lib/coffee-script/index.js
// module id = 1064
// module chunks = 0